import React, { createContext, useState } from 'react'
import data from './fixtures/data.json'

export type AudioContextType = {
  audio: HTMLAudioElement;
  shouldPlayOnStart: boolean;
  setShouldPlayOnStart: (value) => void;
  lastPlayHeadPosition: Array<number>;
  setLastPlayHeadPosition:(number)=>void;
  totalPlayedTimeRanges: Array<object>
  setTotalPlayedTimeRanges: (value) => void;
  audioDurations: Array<number>;
  setAudioDurations: (value) => void;

}

export const AudioContext = createContext<AudioContextType | null>(null)

interface Props {
  children: React.ReactNode
}

// id equals index of station
const AudioProvider: React.FC<Props> = ({ children }) => {

  const [audio] = useState<HTMLAudioElement>(new Audio())
  const [shouldPlayOnStart, setShouldPlayOnStart] = useState(true)
  const [lastPlayHeadPosition, setLastPlayHeadPosition] = useState([...Array(data.stations.length)].map(x => 0))
  const [totalPlayedTimeRanges, setTotalPlayedTimeRanges] = useState([...Array(data.stations.length)].map(x => []))
  const [audioDurations, setAudioDurations] = useState([...Array(data.stations.length)].map(x => 0)) // this is a quick fix: we save duration so that we know if playing audio on station begin is allowed

  return (
    <AudioContext.Provider value={{
      audio, shouldPlayOnStart, setShouldPlayOnStart,
      lastPlayHeadPosition, setLastPlayHeadPosition,
      totalPlayedTimeRanges, setTotalPlayedTimeRanges,
      audioDurations, setAudioDurations
    }}>
      {children}
    </AudioContext.Provider>
  )

}

export default AudioProvider
